import { render, staticRenderFns } from "./FavouriteAccountsCard.vue?vue&type=template&id=08f46caa&"
import script from "./FavouriteAccountsCard.vue?vue&type=script&lang=js&"
export * from "./FavouriteAccountsCard.vue?vue&type=script&lang=js&"
import style0 from "./FavouriteAccountsCard.vue?vue&type=style&index=0&id=08f46caa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports